
const firstStep ={
    "Id": 0,
    "URL": "/vamosComecar",
    "Nome": "Vamos começar!",
    "Campos":[]
}

const resumeStep ={
    "Id": 7,
    "URL": "/resumo",
    "Nome": "Resumo",
    "Campos":[]
}

export const stepsFormGrupos =(grupos = []) =>{
    let steps = [ firstStep ];
    if(grupos)
        steps = steps.concat(grupos) 
    
    let resume = {...resumeStep}

    steps.forEach(step=>{
        if(step.Campos)
            resume.Campos = resume.Campos.concat(step.Campos)
    });
    resume.Campos = resume.Campos.filter(e=>e);
    resume.Id = steps.length;
    steps.push(resume);

    return steps;
}